import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { hasDocument, hasWindow } from '../../utils';
import styles from './google-adsense.module.less';
import arrowDown from '@sb1/ffe-icons/icons/open/300/sm/arrow_downward.svg';
import { Icon } from '@sb1/ffe-icons-react';
import { SmallText } from '@sb1/ffe-core-react';

export const GoogleAdsense = ({ dataAdSlot, dataFullWidthResponsive }) => {
    const clientId = useSelector((state) => state.googleAdSenseClientId);
    const scriptId = 'adsenseScript';
    const isDocumentAvailable = hasDocument();
    const isWindowAvailable = hasWindow();
    const mutationRef = useRef(null);

    useEffect(() => {
        const existingScript = isDocumentAvailable && document?.getElementById(scriptId);

        if (existingScript || !isDocumentAvailable || !isWindowAvailable || !clientId) {
            return;
        }

        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
        script.id = scriptId;
        head.appendChild(script);

        script.onload = () => {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        };
    }, [clientId, isDocumentAvailable, isWindowAvailable]);

    useEffect(() => {
        const pushNewAdTimeout = setTimeout(() => {
            if (mutationRef?.current) {
                const attribute = mutationRef.current.getAttribute('data-ad-status');
                if (window?.adsbygoogle && (attribute === null || attribute === 'unfilled')) {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                }
            }
        }, 1000);

        return () => {
            clearTimeout(pushNewAdTimeout);
        };
    }, []);

    return (
        <div className={styles.adContainer}>
            <SmallText className={styles.adBelowText}>
                Annonse <Icon fileUrl={arrowDown} size="sm" className={styles.icon} />
            </SmallText>

            <div id={dataAdSlot}>
                <ins
                    ref={mutationRef}
                    className={['adsbygoogle', styles.ad].join(' ')}
                    data-ad-client={clientId}
                    data-ad-slot={dataAdSlot}
                    data-full-width-responsive={dataFullWidthResponsive}
                ></ins>
            </div>
        </div>
    );
};
